/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';

export interface FaqAdminControllerTogglePinV1$Params {
  id: string;
}

export function faqAdminControllerTogglePinV1(http: HttpClient, rootUrl: string, params: FaqAdminControllerTogglePinV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
  const rb = new RequestBuilder(rootUrl, faqAdminControllerTogglePinV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqDto>;
    })
  );
}

faqAdminControllerTogglePinV1.PATH = '/api/v1/faqs/admin/{id}/toggle-pin';
